import { c as _c } from "react-compiler-runtime";
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useColumnCallToAction } from './ColumnCallToActionContext';
import { useWidthsSelector } from '../../redux/reduxHooks';
import { getWidths } from '../../resizing/redux/widthsSlice';
import { getPopoverInlineSize } from './getCtaPopoverLayoutWidths';
import { useIsObscuredByFrozenColumn } from './useIsObscuredByFrozenColumn';
import { useFindPopoverAnchorElement } from './useFindPopoverAnchorElement';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColumnCallToActionOverlay = t0 => {
  const $ = _c(16);
  const {
    scrollContainerElementRef,
    numberOfFrozenColumns
  } = t0;
  const callToAction = useColumnCallToAction();
  const widths = useWidthsSelector(getWidths);
  let t1;
  if ($[0] !== callToAction || $[1] !== scrollContainerElementRef || $[2] !== widths) {
    t1 = {
      callToAction,
      scrollContainerElementRef,
      widths
    };
    $[0] = callToAction;
    $[1] = scrollContainerElementRef;
    $[2] = widths;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    anchorElement,
    isAnchorVisible
  } = useFindPopoverAnchorElement(t1);
  const t2 = callToAction === null || callToAction === void 0 ? void 0 : callToAction.isColumnFrozen;
  let t3;
  if ($[4] !== anchorElement || $[5] !== numberOfFrozenColumns || $[6] !== scrollContainerElementRef || $[7] !== t2) {
    t3 = {
      anchorElement,
      scrollContainerElementRef,
      isColumnFrozen: t2,
      numberOfFrozenColumns
    };
    $[4] = anchorElement;
    $[5] = numberOfFrozenColumns;
    $[6] = scrollContainerElementRef;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const isObscuredByFrozenColumn = useIsObscuredByFrozenColumn(t3);
  if (!callToAction || !anchorElement || !isAnchorVisible || isObscuredByFrozenColumn) {
    return null;
  }
  const t4 = callToAction.content;
  let t5;
  if ($[9] !== anchorElement || $[10] !== callToAction) {
    t5 = getPopoverInlineSize(callToAction, anchorElement.getBoundingClientRect().width);
    $[9] = anchorElement;
    $[10] = callToAction;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = `${t5}px`;
  let t7;
  if ($[12] !== anchorElement || $[13] !== callToAction.content || $[14] !== t6) {
    t7 = /*#__PURE__*/_jsx(Popover, {
      arrowSize: "small",
      autoPlacement: false,
      closeOnOutsideClick: false,
      content: t4,
      "data-test-id": "column-call-to-action-popover",
      open: true,
      placement: "bottom",
      target: anchorElement,
      padding: "500",
      borderRadius: "200",
      zIndex: 400,
      inlineSize: t6
    });
    $[12] = anchorElement;
    $[13] = callToAction.content;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};